/**
 * <sticky-buy data-target="#agora"> shows a fixed mobile buy bar once the visitor
 * has scrolled past the first screen and the target buy area is out of view.
 */
class StickyBuy extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('[data-sticky-bar]');
    this.target = document.querySelector(this.dataset.target);
    if (!this.bar) return;
    this.targetVisible = false;
    if (this.target && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        this.targetVisible = entries.some((entry) => entry.isIntersecting);
        this.#update();
      });
      this.observer.observe(this.target);
    }
    this.onScroll = () => this.#update();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('scroll', this.onScroll);
  }

  #update() {
    const show = !this.targetVisible && window.scrollY > window.innerHeight * 0.6;
    if (show === this.bar.hasAttribute('data-visible')) return;
    this.bar.toggleAttribute('data-visible', show);
    this.bar.toggleAttribute('inert', !show);
    this.bar.setAttribute('aria-hidden', String(!show));
  }
}

if (!customElements.get('sticky-buy')) customElements.define('sticky-buy', StickyBuy);
